// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app[data-v-ed03b346] {
  font-family: "AvenirNextLTW01-Regular", Arial, sans-serif;
  font-size: 14px;
}
.app .data[data-v-ed03b346] {
  color: #333;
  float: right;
}
.app table[data-v-ed03b346] {
  border-collapse: collapse;
}
.app .data-row[data-v-ed03b346] {
  color: #666;
  padding: 5px 0px;
}
.app .adjust-date[data-v-ed03b346] {
  margin-top: 5px;
}
.app .table-condensed tr[data-v-ed03b346] {
  border-bottom: 1px solid #cccccc;
}
#afis-app .table-condensed tr td.com-mod-table-label[data-v-ed03b346] {
  padding: 5px;
  text-align: left;
}
#afis-app .table-condensed tr td.com-mod-table-data[data-v-ed03b346] {
  padding: 5px;
  text-align: right;
  width: 12%;
}
.com-mod-level-2-disclosure[data-v-ed03b346] {
  font-size: 12px;
  font-family: "AvenirNextLTW01-Condens 721299", Arial, sans-serif;
  color: #666;
}
`, "",{"version":3,"sources":["webpack://./src/components/Modules/Expenses.vue","webpack://./Expenses.vue"],"names":[],"mappings":"AACA;EACC,yDAAA;EACA,eAAA;ACAD;ADFA;EAKE,WAAA;EACA,YAAA;ACAF;ADNA;EAUE,yBAAA;ACDF;ADTA;EAcE,WAAA;EACA,gBAAA;ACFF;ADbA;EAmBE,eAAA;ACHF;ADhBA;EAuBE,gCAAA;ACJF;ADQA;EACC,YAAA;EACA,gBAAA;ACND;ADSA;EACC,YAAA;EACA,iBAAA;EACA,UAAA;ACPD;ADUA;EACC,eAAA;EACA,gEAAA;EACA,WAAA;ACRD","sourcesContent":["\n.app {\n\tfont-family: \"AvenirNextLTW01-Regular\", Arial, sans-serif;\n\tfont-size: 14px;\n\n\t.data {\n\t\tcolor: #333;\n\t\tfloat: right;\n\t}\n\n\ttable {\n\t\tborder-collapse: collapse;\n\t}\n\n\t.data-row {\n\t\tcolor: #666;\n\t\tpadding: 5px 0px;\n\t}\n\n\t.adjust-date {\n\t\tmargin-top: 5px;\n\t}\n\n\t.table-condensed tr {\n\t\tborder-bottom: 1px solid rgb(204, 204, 204);\n\t}\n}\n\n#afis-app .table-condensed tr td.com-mod-table-label {\n\tpadding: 5px;\n\ttext-align: left;\n}\n\n#afis-app .table-condensed tr td.com-mod-table-data {\n\tpadding: 5px;\n\ttext-align: right;\n\twidth: 12%;\n}\n\n.com-mod-level-2-disclosure {\n\tfont-size: 12px;\n\tfont-family: \"AvenirNextLTW01-Condens 721299\", Arial, sans-serif;\n\tcolor: #666;\n}\n",".app {\n  font-family: \"AvenirNextLTW01-Regular\", Arial, sans-serif;\n  font-size: 14px;\n}\n.app .data {\n  color: #333;\n  float: right;\n}\n.app table {\n  border-collapse: collapse;\n}\n.app .data-row {\n  color: #666;\n  padding: 5px 0px;\n}\n.app .adjust-date {\n  margin-top: 5px;\n}\n.app .table-condensed tr {\n  border-bottom: 1px solid #cccccc;\n}\n#afis-app .table-condensed tr td.com-mod-table-label {\n  padding: 5px;\n  text-align: left;\n}\n#afis-app .table-condensed tr td.com-mod-table-data {\n  padding: 5px;\n  text-align: right;\n  width: 12%;\n}\n.com-mod-level-2-disclosure {\n  font-size: 12px;\n  font-family: \"AvenirNextLTW01-Condens 721299\", Arial, sans-serif;\n  color: #666;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
